import { Component, Input, ViewChild, TemplateRef, ViewChildren, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';

import { ItemBusquedaModel } from '../../utilidades.modelos.index';
import { UtilidadesService, CallesService } from '../../utilidades.servicios.index';

import { environment } from '../../../../environments/environment';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

@Component({
	selector: 'app-buscador-calles',
	templateUrl: './buscador-calles.component.html',
	styles: []
})
export class BuscadorCallesComponent {

	constructor(
		private Utilidades: UtilidadesService,
		private Calles: CallesService
	) {}

//#region Variables Globales

	public Lista: ItemBusquedaModel[] = [];
	public OrigenDeDatos: MatTableDataSource<ItemBusquedaModel>; //Datos que necesita la tabla
	public Columnas: string[] = ['Id', 'Descripcion']; //Columna de las tablas
	@ViewChild(MatSort) Orden: MatSort; //Obtengo el paginador de la pantalla
	public TextoABuscar: string = "";
	private Ventana: MatDialogRef<any, any> = null; //Referencia del popup cuando está abierto.
	@ViewChild("PopUp") PopUp: TemplateRef<any>; //HTML que se va a mostrar en el popup.
	@ViewChildren("txtBuscar") txtBuscar;

	@Output("OnSeleccionarCalle") OnSeleccionarCalle: EventEmitter<ItemBusquedaModel> = new EventEmitter<ItemBusquedaModel>();

	@Input() ControlCalle: FormControl;
	@Input() CodigoLocalidad: string;

//#endregion

//#region Propiedades

	private _calle: ItemBusquedaModel;
	get Calle() {
		this.ActualizarCodigoCalle();
		return this._calle;
	}
	set Calle(value: ItemBusquedaModel) {
		this._calle = value;
		this.ActualizarCodigoCalle();
	}

//#endregion

//#region Eventos de angular

	ngOnChanges(cambios: SimpleChanges): void {
		let CodigoLocalidad = cambios["CodigoLocalidad"];

		if (CodigoLocalidad) {
			this.Calles.Obtener(this.ControlCalle.value, this.CodigoLocalidad).subscribe(c => this.Calle = c);
		}
	}

//#endregion

//#region Porcedimientos

	ActualizarCodigoCalle(): void {
		if (this._calle && this.ControlCalle) {
			if (this._calle.Id != this.ControlCalle.value) {
				if (environment.Debug) {
					console.log(this.ControlCalle.value + " => " + this._calle.Id);
				}

				this.ControlCalle.setValue(this._calle.Id);
			}
		}
	}

	AbrirBuscador(): void {
		this.Calles.Lista(this.CodigoLocalidad != "230000").subscribe(c => {
			this.Lista = c;
			this.CargarLista(this.Lista);
			this.AbrirPopUp();
		});
	}

	CargarLista(lista: ItemBusquedaModel[]): void {
		this.OrigenDeDatos = null;

		//Creo el origen de datos con la lista del servicio
		this.OrigenDeDatos = new MatTableDataSource(lista);

		//Asigno las columnas de órden.
		this.OrigenDeDatos.sort = this.Orden;
	}

	AbrirPopUp(): void {
		this.TextoABuscar = "";
		this.Ventana = this.Utilidades.CuadroHTML(this.PopUp, "700px", "550px");
	}

	Buscar(): void {
		this.OrigenDeDatos.filter = this.TextoABuscar.toLowerCase();
	}

	Seleccionar(item): void {
		this.Calle = item;
		this.Ventana.close();
		this.OnSeleccionarCalle.emit(item);
	}

//#endregion
}